import { axiosInstance } from 'api/instance';
import { Certificate } from 'api/Certificates/types';
import urls from 'api/Certificates/urls';

import { AxiosResponse } from 'axios';

export const getCertificatesRequest = ({ signal }: AbortController): Promise<AxiosResponse<Certificate[]>> => {
  return axiosInstance.get<Certificate[]>(urls.certificatesUrl, { signal });
};
